<template>
  <div
    class="prompt"
    :class="{
      'rounded-l left': position === 'left',
      'rounded-r right': position === 'right',
    }"
    v-tooltip="showText"
  >
    <div
      class="connect-line animate__animated animate__fadeInLeft"
      v-if="position === 'left' && showAnswer && !hideConnect"
      :style="{
        'background-color': color,
      }"
    ></div>
    <div class="justify-center h-18 d-flex">
      <span
        v-if="position === 'right'"
        class="items-center justify-center flex-shrink-0 font-bold
         rounded-l w-9 d-flex text-base-0 horizontal layout center"
        :style="{
          'background-color': showAnswerColor ? color : '#B4BCCF',
        }"
      >
        {{ order }}
      </span>
      <div
        class="flex-grow border-t border-b horizontal layout center content"
        :class="{
          'border-l rounded-l': position === 'left',
          'border-r rounded-r': position === 'right',
        }"
        :style="{
          'background-color': bgWithTextColor,
          'border-color': showAnswerColor || position === 'left' ? color : '#B4BCCF',
        }"
      >
        <span v-if="image" class="mr-2 w-12 min-w-12 image-wrapper">
          <div
            :style="{
              'background-image': `url(${image})`,
              'background-position': '50% 50%',
              'background-size': 'cover',
              'background-repeat': 'no-repeat',
              'width': '48px',
              'height': '48px',
            }"
          ></div>
          <!-- <img :src="image" class="max-h-full"> -->
        </span>
        <span>{{ text }}</span>
      </div>

      <span
        v-if="position === 'left'"
        class="items-center justify-center flex-shrink-0 font-bold
          rounded-r w-9 d-flex text-base-0 horizontal layout center"
        :style="{
          'background-color': color,
        }"
      >
        {{ index }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import util from '@/util'

export default {
  props: {
    position: {
      type: String,
      default: 'left',
    },
    order: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: 0,
    },
    text: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: '#B4BCCF',
    },
    bgColor: {
      type: String,
      default: 'transparent',
    },
    showAnswer: {
      type: Boolean,
      default: false,
    },
    showAnswerColor: {
      type: Boolean,
      default: false,
    },
    hideConnect: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['isTextColourLight']),
    bgWithTextColor() {
      if (this.isTextColourLight) {
        return 'rgba(0, 0, 0, 0.7)'
      }
      return 'rgba(255, 255, 255, 0.85)'
    },
    showText() {
      return util.sanitize(this.text)
    },
  },
}
</script>

<style lang="scss" scoped>
.prompt {
  margin: 16px;
  position: relative;

  &.left {
    margin-right: 24px;
  }
  &.right {
    margin-left: 24px;
  }

  .image-wrapper {
    display: flex;
  }

  .content {
    overflow: hidden;
    display: inline-flex;
    padding: 11px 10px;
    span {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-align: center;
      -webkit-box-orient: vertical;
      line-height: 2rem;
    }
  }
  .connect-line {
    content: "";
    height: 4px;
    width: 28px;
    position: absolute;
    right: -39px;
    top: 33px;
    border-radius: 2px;
  }
}
</style>
